import React, { createContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./master-plan-modification-portal.module.scss";
import close from "../../../images/master-plan-close.svg";
import {
  fetchMasterPlanModificationData,
  FormationTypeNames,
  setResetKrookieData,
} from "../../../services/reducers/master-plan-modification";
import { Outlet, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../hooks/useAppSelector";
import ModalCloseMasterPlan from "./modals/modal-close-master-plan/modal-close-master-plan";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { updateVisibleLayers } from "../../../utils/krookie-helpers";
import { setEnableDrawingTools } from "../../../services/reducers/map";

interface IModalPlanContext {
  closeModalVisible: boolean;
  setCloseModalVisible: (visible: boolean) => void;
}

export const MasterPlanContext = createContext<IModalPlanContext | null>(null);

const MasterPlanModificationPortal = () => {
  const navigate = useNavigate();
  const user = useAppSelector((sotre) => sotre.user.user);
  const { isLoaded } = useAppSelector((state) => state.masterPlanModification);
  const { layers, layersIds, visibleLayersId } = useAppSelector(
    (state) => state.map,
  );
  const dispatch = useAppDispatch();

  if (!user) navigate(-1);

  useEffect(() => {
    if (layers && layers.length > 0 && !isLoaded) {
      dispatch(fetchMasterPlanModificationData());
    }

    return () => {
      dispatch(setResetKrookieData());
    };
  }, [isLoaded, dispatch]);

  useEffect(() => {
    updateVisibleLayers(layersIds, visibleLayersId, dispatch);
    dispatch(setEnableDrawingTools(true));
  }, []);

  const [closeModalVisible, setCloseModalVisible] = useState(false);
  const { t } = useTranslation();

  const formationType = useAppSelector(
    (store) => store.masterPlanModification.selectedFormationType,
  );

  if (!user) navigate(-1);

  return (
    <>
      <div className={styles.mainWrapper}>
        <div
          className={`${styles.header} ${formationType && styles.withFormationType}`}
        >
          <div>
            <h2 className={styles.headTitle}>
              {t("masterPlanModificationPortal.title")}
            </h2>
            <button className={styles.closeButton}>
              <img
                onClick={() => setCloseModalVisible(true)}
                src={close}
                alt={t("masterPlanModificationPortal.closeAlt")}
              />
            </button>
          </div>
          <span>
            {formationType && formationType === FormationTypeNames.Edit
              ? t("masterPlanModificationPortal.editingPlot")
              : formationType === FormationTypeNames.Divide
                ? t("masterPlanModificationPortal.dividingPlots")
                : formationType === FormationTypeNames.Create
                  ? t("masterPlanModificationPortal.creatingPlot")
                  : formationType === FormationTypeNames.Merge
                    ? t("masterPlanModificationPortal.mergingPlots")
                    : null}
          </span>
        </div>
        <MasterPlanContext.Provider
          value={{ closeModalVisible, setCloseModalVisible }}
        >
          <Outlet />
        </MasterPlanContext.Provider>
      </div>
      {closeModalVisible && (
        <ModalCloseMasterPlan onClose={() => setCloseModalVisible(false)} />
      )}
    </>
  );
};

export default MasterPlanModificationPortal;
